/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourceapp2Inputs */

const en_summarysourceapp2 = /** @type {(inputs: Summarysourceapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify app`)
};

const de_summarysourceapp2 = /** @type {(inputs: Summarysourceapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify App`)
};

/**
* | output |
* | --- |
* | "Pulsify app" |
*
* @param {Summarysourceapp2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourceapp2 = /** @type {((inputs?: Summarysourceapp2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourceapp2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourceapp2(inputs)
	return de_summarysourceapp2(inputs)
});
export { summarysourceapp2 as "summarySourceApp" }